@if (isGame(item)) {
<header class="sticky top-0 z-20 bg-white pb-2 dark:bg-black-dark">
  <div
    class="flex flex-wrap justify-between items-center gap-2 mobile:pr-4 mobile:pt-1 mb-3"
  >
    <h2 class="!m-0 min-w-0 max-sm:!max-w-[60%]">
      {{ "MY_COMPLETION_DATES" | translate }}
    </h2>
    <button
      type="button"
      class="btn btn-small !mt-0 shrink-0 !inline-flex items-center gap-1"
      (click)="saveAllDates()"
      [disabled]="pending || timeHistory?.loading"
      [attr.aria-busy]="pending"
    >
      @if (pending) {
      <img src="/assets/images/loading.svg" alt="" class="h-2 w-2" />
      }
      {{ (pending ? "SAVING" : "SAVE") | translate }}
    </button>
  </div>
  @if (saveError || timeHistory?.error; as error) {
  <p
    role="alert"
    class="!my-1 text-sm text-form-error dark:text-form-errorLight"
  >
    {{ error | translate }}
  </p>
  } @else if (saveStatus) {
  <p role="status" class="!my-1 text-sm">{{ saveStatus | translate }}</p>
  }
</header>
<fieldset
  class="min-w-0"
  [disabled]="pending"
  [attr.inert]="pending ? '' : null"
>
  @for ( progress of item.progress?.completionUpdates; track trackByFn($index,
  progress)) { @if ( progress.completion !== 'ongoing' && progress.completion
  !== 'disabled' ) {
  <div class="mb-3">
    <div>
      <span class="capitalize font-bold">{{
        getCompletionLabels(progress.completion) | translate
      }}</span>
    </div>
    <app-edit-work-completion-dates
      [item]="item"
      [completion]="progress"
      (dateChange)="handleDateChange($event)"
    ></app-edit-work-completion-dates>
  </div>
  } }
  <app-work-time-history
    [item]="item"
    [userId]="user._id"
    [disabled]="saving"
    (saveRequested)="saveAllDates()"
    (edited)="saveStatus = ''; saveError = ''"
  ></app-work-time-history>
</fieldset>
}
